import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const DescriptionStepSkeleton = () => (
  <>
    <div className={s.card}>
      <Skeleton
        className={s.title}
        borderRadius={6}
      />
      <Skeleton className={s.inputField} />
    </div>

    <div className={s.card}>
      <Skeleton
        className={s.title}
        borderRadius={6}
      />
      <Skeleton className={s.textareaField} />
    </div>

    <div className={s.capacityCard}>
      <div className={s.capacityText}>
        <Skeleton
          className={s.capacityTitle}
          borderRadius={6}
        />
        <Skeleton
          className={s.capacityDescription}
          borderRadius={6}
        />
      </div>

      <Skeleton
        className={s.capacityControl}
        borderRadius={16}
      />
    </div>
  </>
)
